
import { compose } from 'redux'
import { connect } from 'react-redux'


import { reduxForm, } from 'redux-form';
import { salvar } from '../../actions'
import { withContainerCrud } from '../../../../../components/Utils';
import { withPerfilUser } from '../../hoc';
import { getPermissoesDinamic } from '../../../../sistema/DinamicForms/functions';

let permissoes = [
    "Projetos.Executar",
    "CustomForm.Executar",
    'Primor.Venda.Calculo',
    "Admin.Perfil.Listar"
]

const mapStateToProps = (state, props) => {
    const { PerfilUserReducer, } = state
    let initialValues = props.perfilUser;

    if (props.history && props.history.location && props.history.location.state) {
        const stateL = props.history.location.state;
        initialValues = stateL.initialValuesUsar
    }

    let permissoesDinamic = getPermissoesDinamic(state);
    if (permissoesDinamic)
        permissoes = permissoes.concat(permissoesDinamic)
    return { crudControl: PerfilUserReducer.rCrudSalvar, initialValues, perfilUser: props.perfilUser, permissoes };
};


export default compose(
    withPerfilUser,
    connect(mapStateToProps, { salvar }),
    reduxForm({
        form: 'PerfilUserForm',
    }),
    withContainerCrud({ titulo: "Perfil Usuário" }),


);



// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/components/PerfilForm/PerfilForm.enhancer.js